<template>
    <div id="projects_wrapper">
        <v-snackbar
            v-model="notify_user"
            :timeout="notify_user_duration"
            centered
            top
            elevation="20"
            :color="notify_user_color"
            :class="notify_user_text_color"
            class="pa-6 pt-0 body-1 font-weight-black">
            <div class="center_snackbar_message" v-html="notify_user_message"></div>
        </v-snackbar>

        <v-dialog
            v-model="projectDataDialog"
            fullscreen
            transition="dialog-bottom-transition">
            <v-card class="d-flex align-start" >
                <div style="width: 100%">
                    <ProjectDetails
                        :user_id="this_userId"
                        :project_id="this_projectId"
                        @closeDetailDialog="closeDetailDialog" />
                </div>
            </v-card>
        </v-dialog>

        <div class="pt-0 pb-4" flat>
            <div class="d-flex d-block justify-space-between">
                <div class="d-inline mb-7" style="width: 40%">
                    <v-text-field 
                        v-model="search"
                        hint="Search for an existing project by user name, project title"
                        persistent-hint 
                        single-line 
                        color="primary darken-2" 
                        append-icon="mdi-magnify"
                        class="mr-6">
                    </v-text-field>
                </div>
                <div class="d-flex d-inline mt-3 mb-7">
                    <div class="d-inline">
                        <v-autocomplete 
                            v-model="filterby.module"
                            :items="services" 
                            label="Service(s)" 
                            hide-details 
                            multiple
                            class="mt-n1 mx-3" 
                            color="primary darken-2"
                            @change="filterProjects()">
                        </v-autocomplete>
                    </div>
                    <div class="d-inline">
                        <v-autocomplete 
                            v-model="filterby.service_levels"
                            :items="service_levels" 
                            label="Service Level(s)" 
                            hide-details 
                            multiple
                            class="mt-n1 ml-3" 
                            color="primary darken-2"
                            @change="filterProjects()">
                        </v-autocomplete>
                    </div>
                </div>
                <!-- <div class="d-inline mb-7">
                    <v-menu
                        ref="menu1"
                        v-model="menu1"
                        :close-on-content-click="false"
                        offset-y>
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                label="Date Started"
                                hint="Click the month to quickly change years"
                                outlined
                                persistent-hint
                                prepend-icon="mdi-calendar"
                                ref="input"
                                v-on="on" />
                        </template>
                        <v-date-picker
                            no-title
                            v-on:input="menu1 = false" />
                    </v-menu>
                </div> -->
            </div>

            <!-- <div class="flex-grow-1"></div> -->            
            <!-- <div class="d-flex d-block mt-7 justify-space-between"> -->
                <!-- <div class="d-flex d-inline mb-7">
                    <div class="d-inline">
                        <v-autocomplete 
                            v-model="filterby.module"
                            :items="services" 
                            label="Service(s)" 
                            hide-details 
                            multiple
                            class="mt-n1 mx-3" 
                            color="primary darken-2"
                            @change="filterProjects()">
                        </v-autocomplete>
                    </div>
                    <div class="d-inline">
                        <v-autocomplete 
                            v-model="filterby.service_levels"
                            :items="service_levels" 
                            label="Service Level(s)" 
                            hide-details 
                            multiple
                            class="mt-n1 mx-3" 
                            color="primary darken-2"
                            @change="filterProjects()">
                        </v-autocomplete>
                    </div>
                </div> -->
                <!-- <div class="d-inline">
                    <v-autocomplete 
                        v-model="filterby.status"    
                        :items="statuses"
                        label="Status" 
                        hide-details 
                        multiple
                        class="mt-n1 mx-3" 
                        color="primary darken-2"
                        @change="filterProjects()">
                    </v-autocomplete>
                </div> -->
            <!-- </div> -->
        </div>

        <v-expansion-panels v-model="panel" multiple class="mb-6" active-class="header_bg_color" focusable>
            <v-expansion-panel
                v-for="(status, i) in project_statuses"
                :key="i">
                <v-expansion-panel-header>
                    <!-- :disabled="(search && status.count==0) || filteredProjects[status.id].length==0" -->
                    <v-row no-gutters>
                        <div class="sansation_subtitle primary--text">{{ status.title }}: {{ search ? status.count : filteredProjects[status.id].length }}</div>
                    </v-row>
                    <template v-slot:actions>
                        <v-icon color="grey" large>mdi-chevron-down</v-icon>
                    </template>
                </v-expansion-panel-header>
                
                <v-expansion-panel-content>
                    <div v-if="filteredProjects[status.id].length">
                        <v-data-table
                            :ref="`${status.id}Table`"
                            :headers="headers"
                            :items="filteredProjects[status.id]"
                            :items-per-page="status.value == 'complete' ? 15 : -1"
                            :sort-desc="[true, true]"
                            :search="search"
                            multi-sort >
                            <!-- :sort-by="['status', 'complete']" -->

                            <template v-slot:item="{ item }">
                                <tr @click.stop="openProject( item )" :key="item.project_id+item.user_id" class="ma-0 pa-0">  
                                    <td class="text-start ma-0 pa-0">
                                        <v-progress-linear
                                            v-if="item.complete > 0"
                                            buffer-value="100"
                                            height="6"
                                            striped
                                            :value="item.complete == 0 ? 0 : Math.ceil(item.complete)"
                                            :color="item.status_progress_color"
                                            class="mb-3">
                                        </v-progress-linear>

                                        <span v-html="item.project_data"></span>
                                    </td>
                                    <!-- <td class="text-end ma-0 pa-0">
                                        <v-progress-circular 
                                            :value="item.complete == 0 ? 2 : Math.ceil(item.complete)"
                                            :class="item.status_color"
                                            :rotate="-90"
                                            class="pa-0 ma-0" 
                                            size="43" 
                                            width="4">
                                            <div :style="item.complete == 100 ? 'font-size: .8rem' : 'font-size: .9rem'"
                                                :class="item.status_color+'--text text--darken-2 font-weight-bold'">
                                                {{ item.complete }}
                                            </div>
                                        </v-progress-circular>    
                                    </td> -->
                                    <td class="text-end ma-0 pa-0">{{ item.current_stage }}</td>
                                    <td class="text-end ma-0 pa-0">{{ item.date_saved_label }}</td>
                                    <td class="text-end ma-0 pa-0">{{ item.date_initialized_label }}</td>
                                    <td class="text-end ma-0 pa-0">{{ item.close_date_label }}</td>
                                    <td class="text-end ma-0 pa-0">
                                        <v-icon  
                                            :class="item.expedite ? 'success--text text--darken-2' : 'grey--text text--lighten-2'">
                                            {{ item.expedite ? 'mdi-checkbox-marked' : 'mdi-close-box' }}
                                        </v-icon>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>


<script>
    import axios from "axios";
    import Cookie from 'js-cookie';
    import appUrls from '../helpers/environment'

    import { mdiAccount, mdiPencil, mdiDelete, mdiMagnify } from '@mdi/js'
    import dateFormat, { masks } from "dateformat";

    import ProjectDetails from './ProjectDetails'

    export default {

        components: {
            ProjectDetails
        },

        data: () => ({
            name: 'Projects',
            notify_user: false,
            notify_user_color: 'success',
            notify_user_text_color: 'primary--text',
            notify_user_message: '',
            notify_user_duration: 6000,
            icons: {
                accountIcon: mdiAccount,
                pencilIcon: mdiPencil,
                deleteIcon: mdiDelete,
                magnifyIcon: mdiMagnify,
            },
            dialog: false,
            fire_dialog: true,
            errorDialog: false,
            projectDataDialog: false,
            errorMsg: '',
            search: '',
            project_search: '',
            project_details: {},
            showCompletedDate: false,
            filter_search: false,
            filterby: {
                module: [],
                status: ['open', 'review', 'processing'],
                service_levels: [],
                date_range: {
                    start: '',
                    end: ''
                }
            },
            headers: [
                { text: 'Project Data',     value: 'complete',         align: 'start', sortable: true, class: 'tbl_headers', width: '' },
                { text: 'Current Stage',    value: 'current_stage',    align: 'end',   sortable: true, width: '12%' },  
                { text: 'Last Saved Date',  value: 'date_saved',       align: 'end',   sortable: true, width: '11%' },             
                { text: 'Date Started',     value: 'date_initialized', align: 'end',   sortable: true, width: '9%' },
                { text: 'Est. End Date',    value: 'close_date',       align: 'end',   sortable: true, width: '9%' },  
                { text: 'Expedited',        value: 'expedite',         align: 'end',   sortable: true, width: '9%' },
            ],
            services: [
                { id: 1, text: 'Contingency',           value: ["contingency-starter", "contingency-premium", "contingency-elite"] },
                { id: 2, text: 'Deal Support',          value: ["deal-support-starter", "deal-support-premium", "deal-support-elite"] },
                { id: 3, text: 'Employment Resources',  value: ["employment-resources-starter", "employment-resources-premium", "employment-resources-elite"] },
                { id: 4, text: 'Entity Maintenance',    value: ["entity-maintenance-program"] },
                { id: 5, text: 'Entity Support',        value: ["entity-support-starter", "entity-support-premium", "entity-support-elite"] },
                { id: 6, text: 'Equity Sharing Plan',   value: ["equity-starter", "equity-premium", "equity-elite"] },
                { id: 7, text: 'Merger',                value: ["merger-premium", "merger-elite"] },
                { id: 8, text: 'Succession Planning',   value: ["succession-premium", "succession-elite"] },
                { id: 9, text: 'Valuation',             value: ["valuation-starter", "valuation-premium", "valuation-elite"] },
            ],
            service_levels: [
                { id: 1, text: 'Starter', value: 'starter' },
                { id: 2, text: 'Premium', value: 'premium' },
                { id: 3, text: 'Elite',   value: 'elite' },
            ],
            statuses: [
                { id: 1, text: 'Open',       value: 'open' },
                { id: 2, text: 'Review',     value: 'review' },
                { id: 3, text: 'Processing', value: 'processing' },
                { id: 4, text: 'Complete',   value: 'complete' },
                { id: 5, text: 'Closed',     value: 'closed' }, 
                { id: 6, text: 'Hold',       value: 'hold' },
            ],
            project_statuses: [
                { title: 'Awaiting Questionnaire',  id:'open',       count: 0 },
                { title: 'Questionnaire Submitted', id:'review',     count: 0 },
                { title: 'In Process',              id:'processing', count: 0 },
                { title: 'On Hold',                 id:'hold',       count: 0 },
                { title: 'Complete',                id:'complete',   count: 0 },
                { title: 'Closed',                  id:'closed',     count: 0 },
            ],
            panel: [0],
            modules: [],
            projects: [],
            selectedStatus: Number,
            filteredProjects: {
                closed: [],
                complete: [],
                hold: [],
                open: [],
                processing: [],
                review: []
            },
            admin_matches: [],
            menu1: false,
            this_userId: '',
            this_projectId: ''
        }),
        
        
        watch: {
            dialog (val) {
                val || this.close()
            },
            projects () {
                this.filterProjects();
            },
            search () {
                this.handlePanels();
            }
        },
        
        created () {
            this.getModules()
        },

        mounted () {
            //setTimeout(()=>{ 
                this.getProjects()
                this.setModuleSelection()
            //}, 500)
        },

        methods: {
            openProject: async function ( prj ) {
                this.$router.push( { path: '/module_roadmap/'+prj.module_key+'/'+prj.project_id } );
            },

            closeDetailDialog: function () {
                this.projectDataDialog = false
                this.this_userId = ''
                this.this_projectId = ''
            },

            getProjects: async function () {
                const all_projects = await axios.get(`${appUrls.api}/api/partner_projects`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                })
                
                if ( all_projects.data.outcome ) {
                    this.projects = all_projects.data.projects;

                    this.projects = all_projects.data.projects.filter( prj => {
                        return this.modules.find(obj => obj.module_id === prj.module_id)
                    })

                    let i = 0;
                    for( let prj of this.projects ) {
                        if ( this.modules.find(obj => obj.module_id === prj.module_id) != undefined ) {
                            
                            this.projects[i].date_initialized = this.projects[i].date_initialized != null ? new Date(this.formatDate(this.projects[i].date_initialized)).getTime() : 0;
                            this.projects[i].date_initialized_label = this.projects[i].date_initialized != 0 ? this.formatDate(this.projects[i].date_initialized) : 'NA';

                            this.projects[i].close_date = this.projects[i].close_date != null ? new Date(this.formatDate(this.projects[i].close_date)).getTime() : 0;
                            this.projects[i].close_date_label = this.projects[i].close_date != 0 ? this.formatDate(this.projects[i].close_date) : 'NA';
                            
                            this.projects[i].date_saved = this.projects[i].date_saved != null ? new Date(this.formatDate(this.projects[i].date_saved)).getTime() : 0;
                            this.projects[i].date_saved_label = this.projects[i].date_saved != 0 ? this.formatDate(this.projects[i].date_saved) : 'NA';

                            switch (this.projects[i].status) {
                                case 'open': // OPEN
                                case 'review': // REVIEW
                                case 'processing': // PROCESSING
                                    // this.projects[i].status_text  = this.projects[i].status == 'review' ? 'Review' : 'Open';
                                    this.projects[i].status_text  = this.projects[i].status.charAt(0).toUpperCase() + this.projects[i].status.slice(1);
                                    this.projects[i].status_color = 'secondary--text';
                                    this.projects[i].status_progress_color = 'secondary';
                                    this.projects[i].status_hex_color = '#94BB50';
                                break;
                                case 'complete': // COMPLETE
                                    this.projects[i].status_text  = 'Complete';
                                    this.projects[i].status_color = 'primary--text';
                                    this.projects[i].status_progress_color = 'primary';
                                    this.projects[i].status_hex_color = '#248A9A';
                                break;
                                case 'closed': // CLOSED
                                    this.projects[i].status_text  = 'Closed';
                                    this.projects[i].status_color = 'coffee--text';
                                    this.projects[i].status_progress_color = 'coffee';
                                    this.projects[i].status_hex_color = '#505149';
                                break;
                                default: // HOLD
                                    this.projects[i].status_text  = 'Hold';
                                    this.projects[i].status_color = 'deep-orange--text';
                                    this.projects[i].status_progress_color = 'deep-orange darken-1';
                                    this.projects[i].status_hex_color = '#F4511E';
                                break;
                            }

                            // PROJECT TITLE & INTERNAL TITLE
                            const internal_title = prj.internal_project_title != null ? prj.internal_project_title : ''
                            const user_prj_title = prj.project_title != null ? prj.project_title : ''
                            const mod_divider    = internal_title != '' || user_prj_title != '' ? ' :: ' : ': '
                            const title_divider  = internal_title != '' && user_prj_title != '' ? ' :: ' : ''
                            const project_label  = `<div class="sansation d-flex justify-space-between ma-0 pa-0">
                                    <div class="ma-0 pa-0"><span class="primary--text">${prj.module_name}${mod_divider}</span><span class="font-weight-thin grey--text">${internal_title}</span><span class="font-weight-thin grey--text text--darken-2">${title_divider}${user_prj_title}</span></div>
                                    <div class="${this.projects[i].status_color} font-weight-bold ma-0 pa-0">${prj.complete > 0 ? Math.ceil(prj.complete)+'%' : ''}</div>
                                    </div>`

                            // PROJECT DATA
                            // REORDER ARRAY BASED ON NORTHWESTERNMUTUAL PROJECTS 
                            const reorderedArray = this.projects[i].client_info.sort((a, b) => {
                            // Extract emails from array elements
                            const emailA = a.match(/\b[A-Za-z0-9._%+-]+@[\w.-]+\.[A-Z|a-z]{2,}\b/);
                            const emailB = b.match(/\b[A-Za-z0-9._%+-]+@[\w.-]+\.[A-Z|a-z]{2,}\b/);

                            // Check if email addresses contain specific domains
                            const containsNmComA = emailA && emailA[0].includes('@nm.com');
                            const containsNmComB = emailB && emailB[0].includes('@nm.com');
                            const containsNorthwesternMutualComA = emailA && emailA[0].includes('@northwesternmutual.com');
                            const containsNorthwesternMutualComB = emailB && emailB[0].includes('@northwesternmutual.com');
                            const isAdvisorPracticeA = emailA && emailA[0] === 'ADVISORPRACTICE@northwesternmutual.com';
                            const isAdvisorPracticeB = emailB && emailB[0] === 'ADVISORPRACTICE@northwesternmutual.com';
                            const isCdAdpmteamA = emailA && emailA[0] === 'cd-adpmteam@northwesternmutual.com';
                            const isCdAdpmteamB = emailB && emailB[0] === 'cd-adpmteam@northwesternmutual.com';

                            // Sort logic
                            if (containsNmComA && !containsNmComB) {
                                return -1; // Place items with @nm.com at the beginning
                            } else if (!containsNmComA && containsNmComB) {
                                return 1; // Place items with @northwesternmutual.com at the end
                            } else if (containsNorthwesternMutualComA && !containsNorthwesternMutualComB) {
                                return 1; // Place items with @northwesternmutual.com at the end
                            } else if (!containsNorthwesternMutualComA && containsNorthwesternMutualComB) {
                                return -1; // Place items with @nm.com at the beginning
                            } else if (isAdvisorPracticeA && !isAdvisorPracticeB) {
                                return 1; // Place items with ADVISORPRACTICE@northwesternmutual.com at the end
                            } else if (!isAdvisorPracticeA && isAdvisorPracticeB) {
                                return -1; // Place items with @nm.com at the beginning
                            } else if (isCdAdpmteamA && !isCdAdpmteamB) {
                                return 1; // Place items with cd-adpmteam@northwesternmutual.com at the end
                            } else if (!isCdAdpmteamA && isCdAdpmteamB) {
                                return -1; // Place items with @nm.com at the beginning
                            } else {
                                return 0; // Maintain the original order for other cases
                            }
                            });

                            // const client_first = this.projects[i].client_info.shift()
                            const all_users = `<li class="ma-0 pa-0">${reorderedArray.join("</li><li class='ma-0 pa-0'>")}`
                            const client_info = `<ul class="avenir_book mt-n3 mb-0 py-0">${all_users}</ul>`

                            // SET THE project_data DATAPOINT
                            this.projects[i].project_data = `${project_label}<br>${client_info}`

                            i++;
                        }
                    }
                    // console.log(this.projects)
                }
            },

            getModules: async function () {
                const all_modules = await axios.get(`${appUrls.api}/api/admin/all_modules`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                })
                
                if ( all_modules.data.outcome ) {
                    this.modules = all_modules.data.modules;

                    let admin_modules = this.modules.map(mod => {
                        if ( mod.module_key != 'buyer' ) {
                            let found = mod.srg_team.experts.map( x => {
                                if ( x.email == Cookie.get('srge') ) {
                                    return mod.module_key
                                }
                            })
                            if ( found.includes(mod.module_key) ) {
                                return mod.module_key
                            }
                        }
                    })
                    admin_modules = admin_modules.filter( Boolean )

                    let admin_matches = admin_modules.map(key => {
                        return this.services.find(service => service.value.includes(key)).id    
                    })
                    this.admin_matches = admin_matches
                }
            },

            formatDate: function ( date ) {
                return dateFormat(date, "mm/dd/yyyy")
            },

            setModuleSelection: async function () {
                const admin_modules = this.services.filter(service => this.admin_matches.includes(service.id))
                this.filterby.module = admin_modules.map(service => service.value)
                this.filterby.service_levels = ['starter', 'premium', 'elite']
                this.filterProjects()
            },

            handlePanels : async function () {
                // ALL PANELS HAVE TO BE OPEN FOR $refs TO RECOGNIZE IT
                this.panel = [0,1,2,3,4,5]

                this.$nextTick(() => {
                    let panel=[]
                    this.project_statuses.map( (sec, ndx) => {
                        if ( this.$refs[sec.id+'Table'] != undefined ) {
                            sec.count = this.$refs[sec.id+'Table'][0].$children[0].computedItems.length
                            if ( this.$refs[sec.id+'Table'][0].$children[0].computedItems.length ) panel.push(ndx)
                        }
                    })
                    this.panel = panel
                })
            },

            filterProjects: async function () {
                let allFilteredProjects = []

                let merged_modules_filter = this.filterby.module.length ? [].concat.apply([], this.filterby.module) : this.projects
                if ( merged_modules_filter.length ) {
                    allFilteredProjects = this.projects.reduce( (projects, prj) => {
                        if ( merged_modules_filter.includes(prj.module_key) ) {
                            projects.push(prj)
                        }
                        return projects
                    }, [])
                }

                let levels_data_set = allFilteredProjects.length ? allFilteredProjects : this.projects                
                if ( this.filterby.service_levels.length ) {
                    allFilteredProjects = levels_data_set.reduce( (projects, prj) => {
                        if (prj.module_key === 'entity-maintenance-program') {
                            projects.push(prj)
                        }
                        this.filterby.service_levels.forEach( text => {
                            if ( prj.module_key.indexOf(text) != -1 ) {
                                projects.push(prj)
                            }
                        })
                        return projects
                    }, [])
                }

                // let status_data_set = allFilteredProjects.length ? allFilteredProjects : this.projects                
                // if ( this.filterby.status.length ) {                    
                //     allFilteredProjects = status_data_set.reduce( (projects, prj) => {
                //         if ( this.filterby.status.includes(prj.status) ) {
                //             projects.push(prj)
                //         }
                //         return projects
                //     }, [])
                // }

                let closed_status=[], complete_status=[], hold_status=[], open_status=[], processing_status=[], review_status=[]
                allFilteredProjects.map( project => {
                    if ( project.status == 'closed' )    closed_status.push(project)
                    if ( project.status == 'complete' )  complete_status.push(project)
                    if ( project.status == 'hold' )      hold_status.push(project)
                    if ( project.status == 'open' )      open_status.push(project)
                    if ( project.status == 'processing') processing_status.push(project)
                    if ( project.status == 'review')     review_status.push(project)
                })
                
                this.filteredProjects = {
                    closed: closed_status,
                    complete: complete_status,
                    hold: hold_status,
                    open: open_status,
                    processing: processing_status,
                    review: review_status
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #projects_wrapper {
        width: 100%;
        margin: 0 auto;
        padding: 0;
        background-color: none;
    }
    tr:nth-of-type(odd) {
        background-color: rgba(223, 233, 236, .25);
    }
    >>> tbody tr {
        cursor: pointer !important;
    }
    td.no_extra_border {
        border-bottom: 0 !important;
    }
    .title {
        padding: .5em;
    }
    #new_btn {
        width: 100%;
        text-align: right;
    }
    .listing_row {
        text-align: left;
    }
    tr:nth-of-type(even) {
        background-color: rgba(0, 0, 0, .05);
    }
    .tbl_headers {
        padding: 0 !important;
    }
    .dialog_title_bkg {
        background-color: #2196f3; /* #17a2b8 */
        color: #fff
    }
    .icon-size-small {
        width: 2.25rem;
    }
    .v-expansion-panel-header.v-expansion-panel-header {
        padding: 1em !important;
        margin: 0 !important;
    }
    .v-expansion-panel-header.v-expansion-panel-header--active,
    .v-expansion-panel-header.v-expansion-panel-header:hover {
        background: #eef7f8;
        padding: 1em !important;
        margin: 0 !important;
        /* background-color: rgba(189, 235, 249, 0.25); */
    }
    >>> .v-expansion-panel-content__wrap {
        padding: .5em 0 !important; 
        /* margin: 0 !important;     */
    }
    >>> .v-data-table .v-data-table__wrapper > table > thead > tr > th {
        padding: 0 1em 0 1em !important;
        /* margin: 0 !important; */
        /* border: 1px solid green !important; */
    }
    .v-data-table .v-data-table__wrapper > table > tbody > tr > td {
        padding: .8em 1em .8em 1em !important;
        margin: 0 !important;
        /* border: 1px solid blue !important; */
    }
</style>


// WEBPACK FOOTER //
// src/components/PartnerProjects.vue